import { Box, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import Header from '../common/Header'
import HeaderMobile from '../HeaderMobile'

export type IPageLayoutProps = {
  children: React.ReactNode
}

const PageLayout: React.FC<IPageLayoutProps> = ({ children }) => {
  const theme = useTheme()
  const isMD = useMediaQuery(theme.breakpoints.up('md'))
  return (
    <>
      <main>
        {!isMD ? <HeaderMobile /> : <Header />}

        {/* <Header /> */}
        <Box sx={{ pt: !isMD ? 80 : 86, minHeight: 'calc(100vh - 66px)' }}>{children}</Box>
      </main>
    </>
  )
}

export default PageLayout
